import { APIFetchError } from "@cur8/api-client";

/**
 * APIBackend answers 409 "ECG Device Offline" when the ECG device is not
 * connected to IoT Hub. On PATCH a 409 can also mean "already assigned", but
 * this app always assigns with `force: true`, which never returns that.
 */
export function isEcgDeviceOffline(error: unknown): boolean {
  return error instanceof APIFetchError && error.response.status === 409;
}

/**
 * The `assignError` search param entry-point views pass to the assign page
 * when their direct assign fails, so it can say why.
 */
export function assignErrorParam(error: unknown): "offline" | "1" {
  return isEcgDeviceOffline(error) ? "offline" : "1";
}
